'use client';

import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import { ChartInstantApyLoading } from '../ChartInstantApy';
import InstantRatesSectionLayout from '../InstantRatesSectionLayout';
const InstantRatesSectionLoading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <InstantRatesSectionLayout chartInstantApySlot={<ChartInstantApyLoading />} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default memo(InstantRatesSectionLoading);